import React from 'react'

import { ADD_QUICKY_URL } from '../../urls'

const CreateQuickyAction = ({ poll, children }) => {
  let { id, header } = poll
  let quickyUrl = `${ADD_QUICKY_URL}?poll=${id}&topic_name=QMA/${id}&description=${header}`
  return (
    <a
      target="_blank"
      href={quickyUrl}
      rel="noopener noreferrer"
      className="link f6 normal gray ph3 relative"
    >
      {children}
    </a>
  )
}

export default CreateQuickyAction



// WEBPACK FOOTER //
// ./src/components/polls/CreateQuickyAction.js